import { AuthContext } from 'contexts'
import MainLayout from 'layout';
import { LoadingPage } from 'modules/Public';
import React, { useContext } from 'react'
import { Navigate, useLocation } from 'react-router-dom';

function ProtectedRoute({children}) {
  const { state } = useContext(AuthContext);
  const location = useLocation();

  if(state.loading){
    return <LoadingPage/>
  }
  else if(!state.loading && !state.token){
    return <Navigate to={'/login'} replace state={{ from: location}}/>
  }
  else if(!state.loading && state.token){
    return <MainLayout>{children}</MainLayout>
  }
  // else if(state.error){
    //   if(state.error === '500'){
      //     return <div className='h-screen w-screen flex justify-center items-center bg-white'>
      //       server error 500
      //     </div>
      //   }
      // }
      // else if(state.userInfo?.forms.find((el) => el === children?.formCode)){
        //   return <MainLayout>{children}</MainLayout>
        // }
        else {
          return <div className='flex justify-center h-full items-center'>Таны эрх хүрэхгүй байна</div>
        }
        // else {
        //   return <Navigate to={'/register'}/>
        // }
        
}

export default ProtectedRoute